/* eslint-disable max-len */
import { Container, Row } from "react-bootstrap";
import CheckmarkIcon from "../../../icons/CheckmarkIcon";

const Complete = () => (
	<Container className="assessment-view bg-white rounded-3">
		<Row className="d-flex flex-column gap-4 text-center">
			<CheckmarkIcon background={"var(--bs-success"} />
			<h2 className="fs-21">You&apos;ve Successfully Completed Your EQQO Report</h2>
			<p className="fs-18">You can now go to your EQQO Report Dashboard to review any of the data you&apos;ve just reviewed. You can also download a full report of your results at any time.</p>
		</Row>
	</Container>
);

export default Complete;
